const getVideoType = videoId => {
  if (!!videoId && /[a-z]/g.test(videoId)) {
    return 'wistia';
  }
  return 'vimeo';
};

export default getVideoType;
